export const BATTERY_ACTIVITY_TYPES = {
  KEPT_FOR_CHARGING: 1,
  CHECKED_IN_SOS: 2,
  ASSIGNED_SOS: 3,
  WITHDRAWN_LOCKER: 4,
  DEPOSITED_LOCKER: 5,
  ASSIGNED_TRIP: 6,
  FULLY_CHARGED: 7,
  CHECKED_IN: 8,
  CHECKED_OUT: 9,
  ASSIGNED_SWAP: 10,
  ASSIGNED_RENTAL: 11,
  ASSOCIATED_RENTAL: 12,
  ASSIGNED_TRANSFER: 13,
  ASSIGNED_SESSION: 14,
  ASSOCIATED_SESSION: 15,
  ADDED_TO_SERVICE: 16,
  SERVICE_COMPLETED: 17,
  REMOVED_FROM_TRIP: 18,
  REMOVED_FROM_SESSION: 19,
};

export const ACTIVITY_TYPES = BATTERY_ACTIVITY_TYPES;
